<app-sidebar-nav
    [items]="menuItems.getMenuitem()"
    [collapsed]="collapsed"
    (collapsedChange)="collapsedChange.emit($event)">
  <div sidebar-footer>
    © 2025 Micro Merchant Systems, Inc.
    <br>Version ACv18.1 All rights reserved.
  </div>
</app-sidebar-nav>
